import z from "zod";

export const mergeProjectSchema = z
	.object({
		sourceProjectId: z.uuid(),
		targetProjectId: z.uuid(),
		direction: z.enum(["source_to_target", "target_to_source"]),
	})
	.refine((data) => data.sourceProjectId !== data.targetProjectId, {
		message: "sourceProjectId and targetProjectId must be different",
		path: ["targetProjectId"], // optional: highlight the field that caused the error
	});

export type MergeProjectSchema = z.infer<typeof mergeProjectSchema>;
